<template>
  <div class="ClueQuery">
    <div class="ClueEntry1">
      <van-nav-bar fixed title="线索审核" left-arrow @click-left="() => $router.go(-1)" />
      <div class="list">
        <div class="item" v-for="(item,index) in tables" :key="index" @click="toxiansuodetail(item.id)">
          <div class="hang">
            <div class="left">线索名称</div>
            <div class="right">{{item.projectName}}</div>
          </div>
          <div class="hang">
            <div class="left">联系人/电话</div>
            <div class="right">{{item.contactPerson}}({{item.contactNumber}})</div>
          </div>
          <div class="hang">
            <div class="left">线索状态</div>
            <div class="right">{{item.statusDescription}}</div>
          </div>

          <div class="hang">
            <div class="left">项目参与</div>
            <div class="right">{{item.joinProject}}</div>
          </div>
          <div class="hang">
            <div class="left">创建时间</div>
            <div class="right">{{item.creationTime}}</div>
          </div>

          <!-- 按钮 -->
          <van-button color="#2490F8" class="btn" v-if="item.businessMobile!=null&&item.moneyCode==null" @click.stop="yes(item.id)">确认</van-button>
          <van-button color="#2490F8" class="btn" style="margin-left:10px" v-if="item.businessMobile!=null&&item.moneyCode==null" @click.stop="back(item.id)">退回</van-button>
          <van-button color="#2490F8" class="btn" style="margin-left:10px" v-if="item.moneyCode!==null&&item.userId==item.businessUserId" @click.stop="jiaoban(item.id)">交办</van-button>

        </div>
      </div>
    </div>

    <van-dialog v-model="show" title="退回线索" message='您确定退回此线索吗？' show-cancel-button :before-close="onBeforeClose">
      <van-field v-model="value" placeholder="请输入退回意见" />
    </van-dialog>
    <!-- 交办 -->
    <van-dialog v-model="show2" title="交办" show-cancel-button :before-close="jiaobaning">
      <van-cell is-link :title="title" @click="isbumen = true" />
      <van-cell is-link :title="title2" @click="selectpeople" />
    </van-dialog>
    <!-- 选择部门 -->
    <van-action-sheet v-model="isbumen" :actions="actions" @select="onSelect" />
    <!-- 选择人 -->
    <van-action-sheet v-model="ispeople" :actions="actions2" @select="onSelect2" />
  </div>
</template>

<script>
import { Dialog } from 'vant';
import { Notify } from 'vant';
export default {
  data() {
    return {
      title: '部门',
      title2: '科室',
      jiaobanform: {
        bumenid: null,
        peopleid: null
      },
      ispeople: false,
      isbumen: false,
      show2: false,
      value: '',
      backid: 0,
      jiaobanid: 0,
      show: false,
      tables: [],
      query: {
        Searchkey: '',
        Canye: '',
        Contact: '',
        NatureId: '',
        Status: '',
        PageSize: 10,
        PageIndex: 1,
        ZrCompanyId: 1
      },
      actions: [{ name: '选项一' }, { name: '选项二' }, { name: '选项三' }],
      actions2: [],
    }
  },
  created() {
    this.getlist()
  },

  methods: {
    onSelect(e) {
      this.isbumen = false;
      this.title = e.name
      this.jiaobanform.bumenid = e.value
      //选完部门之后，调用人的接口
      this.getpeople(e.value)
    },
    getpeople(id) {
      this.request({
        url: `v1.0/User/getKYUsersByOrgId2?OrgId=${id}`,
        method: "GET",
      }).then((res) => {
        console.log(res, 'people')
        this.actions2 = JSON.parse(JSON.stringify(res.data).replace(/fullName/g, "name"));
      })
    },
    onSelect2(e) {
      this.title2 = e.name,
        this.jiaobanform.peopleid = e.userId
      this.ispeople = false
    },
    selectpeople() {
      if (this.jiaobanform.bumenid == null) {
        Notify({ type: 'danger', message: '请先选择部门' });
        return
      }
      this.ispeople = true
    },
    getlist() {
      this.request({
        url: "/v1.0/Clues/getCluesNewList2",
        method: "GET",
        params: this.query
      }).then((res) => {
        console.log(res, 888)
        this.tables = res.data.items
        res.data.items.forEach(item => {
          item.statusDescription = "待确认";
          //
          if (item.moneyCode !== null) {
            item.statusDescription = "已采纳";
          }
        })
      })
    },
    //进到详情页
    toxiansuodetail(id) {
      console.log(id, 88)
      this.$router.push(`/index/clueDetail?id=${id}`);
    },
    yes(id) {
      console.log(id, 77777)
      Dialog.confirm({
        title: '确认线索',
        message: '您确定此线索有效吗？',
      })
        .then(() => {
          console.log(id, "yes");
          this.request({
            url: `/v1.0/project/SetMoneyCode?projectId=${id}`,
            method: "GET",
          }).then((res) => {
            console.log(res, 4444555)
            if (res.success) {
              Notify({ type: 'success', message: '线索已确认' });
              this.getlist()
            } else {
              Notify({ type: 'danger', message: res.message });
            }
          })
        })
        .catch(() => {
          // on cancel
        });
    },
    back(id) {
      this.show = true
      this.backid = id
    },
    //交办提交
    jiaobaning(action, done) {
      if (action === "confirm") {
        if (this.jiaobanform.bumenid == null) {
          Notify({ type: 'danger', message: '请先选择部门' });
          return done(false)
        } else if (this.jiaobanform.peopleid == null) {
          Notify({ type: 'danger', message: '请选择一个科室' });
          return done(false)
        } else {
          // 交办接口
          console.log(1)
          this.request({
            url: '/v1.0/Project/jiaobanProject',
            method: "POST",
            data: {
              Id: this.jiaobanid,
              User: this.jiaobanform.peopleid
            },
          }).then((res) => {
            console.log(res)
            if (res.success) {
              Notify({ type: 'success', message: '交办成功' });
              this.getlist()
              return done()
            } else {
              Notify({ type: 'danger', message: res.message });
              return done()
            }
          })
        }
      } else {
        return done()
      }
    },
    //退回
    onBeforeClose(action, done) {
      if (action === "confirm") {
        if (this.value == '') {
          Notify({ type: 'danger', message: '请输入退回意见' });
          return done(false)
        } else {
          this.request({
            url: `/v1.0/Clues/CancelCuleCheck?projectId=${this.backid}&cancelRemark=${this.value}`,
            method: "GET",
          }).then((res) => {
            console.log(res, 4444555)
            if (res.success) {
              Notify({ type: 'success', message: '线索已退回' });
              this.getlist()
              return done()

            } else {
              Notify({ type: 'danger', message: res.message });
              return done()
            }
          })
            .catch(() => {
              // on cancel
            });
          return done()
        }
      } else {
        return done()
      }
    },
    jiaoban(id) {
      this.show2 = true
      this.jiaobanid = id
      this.getbumendata()
    },

    //请求部门
    getbumendata() {
      this.request({
        url: 'v1.0/Orgainization/GetAllOranization2',
        method: "GET",
      }).then((res) => {
        console.log(res, 'rimima')
        this.actions = JSON.parse(JSON.stringify(res.data).replace(/text/g, "name"));
      })

    }
  }
}
</script>

<style scoped>
.ClueQuery {
  margin-top: 8vh;
}
.hang {
  margin-top:10px ;
  display: flex;
  justify-content: space-between;
}
.item {
  width: 90%;
  margin: 10px auto;
  background: #FFFFFF;
  padding: 1rem;
}
.btn {
  margin-top: 15px;
  border-radius:8px;
  height:30px;
  color: #ffffff !important;
}
</style>